import {StyleSheet} from 'react-native';
import Typography from '../../../../shared/constants/Typography';

export const createSearchInputStyles = (theme: any) =>
  StyleSheet.create({
    container: {
      flex: 1,
      flexDirection: 'row',
      backgroundColor: theme.backgroundColor,
      borderRadius: Typography.radius.radius8,
      paddingLeft: Typography.padding.padding12,
      borderColor: theme.borderColor,
      borderWidth: Typography.borderWidth.borderWidth1,
      alignItems: Typography.textAlign.centerAlign,
      maxHeight: Typography.height.dropDownheight,
      height: Typography.height.dropDownheight,
    },
    leftContainer: {
      flexDirection: 'row',
      gap: Typography.gap.gap8,
    },
    closeIcon: {
      alignItems: Typography.textAlign.centerAlign,
      maxHeight: Typography.height.dropDownheight,
      flexDirection: 'row',
    },
    rightView: {
      flex: 1,
      flexDirection: 'row',
      paddingLeft: Typography.padding.padding12,
      gap: Typography.gap.gap4,
      alignItems: Typography.textAlign.centerAlign
    },
    input: {
      flex: 1,
      fontSize: Typography.fontSize.fontSize14,
      color: theme.inputColor,
      fontFamily: Typography.fontFamily.inter,
      height: Typography.height.dropDownheight,
      fontWeight: Typography.fontWeight.regular,
    },
    innerContainer: {
      flex: 1,
      flexDirection: 'row',
      alignItems: Typography.textAlign.centerAlign,
      gap: Typography.gap.gap4,
    },
    sortDropdown: {
      minWidth: Typography.width.width80,
      flexShrink: 0,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      borderLeftWidth: 0,
      borderBottomLeftRadius: Typography.radius.radius8
    },
    borderDropdown: {
      borderBottomLeftRadius: Typography.radius.radius8
    },
    dropdownText: {
      fontSize: Typography.fontSize.fontSize14,
      fontFamily: Typography.fontFamily.inter,
      fontWeight: Typography.fontWeight.medium,
      lineHeight: Typography.lineHeight.lineHeight20,
      color: theme.searchResultColor,
    },
    customLabelStyle: {
      fontSize: Typography.fontSize.fontSize14,
      fontFamily: Typography.fontFamily.inter,
      fontWeight: Typography.fontWeight.medium,
      lineHeight: Typography.lineHeight.lineHeight20,
    },
    searchArrow: {
      height: Typography.height.dropDownheight,
      backgroundColor: theme.searchResultBGColor,
      borderColor: theme.borderColor,
      borderRightColor: 'transparent',
      borderRadius: Typography.radius.radius8,
      borderWidth: Typography.borderWidth.borderWidth1,
      width: Typography.width.width40,
      justifyContent: 'center',
      alignItems: 'center',
      padding: 0,
      margin: 0,
    },
    enableSearchArrow: {
      borderColor: theme.activeBorderColor,
      // borderBottomColor: theme.activeBorderColor,
    },
    enableSearchHoverArrow: {
      borderColor: theme.hoverBorderColor,
      // borderBottomColor: theme.hoverBorderColor,
    }
  });
